import React, { useState } from "react";
import GirlChild from "../assets/girlThoughtImg.svg";
import BookImg from "../assets/OpenBookImg.svg";
import PinkBookImg from "../assets/OpenBookPinkImg (2).svg";
import plusStarImg from "../assets/plusStar.svg";
import greenHeartImg from "../assets/greenHeart.svg";
import redHeartImg from "../assets/redHeart.svg";
import RedHeartImg from "../assets/redHeart.svg";
import CurriculumOfLovePDF from "../assets/CurriculumOfLove.pdf";
import AdmContactUsImg from "../assets/AdmContactUs.svg";
import CustomHeading from "./custom/CustomHeading";
import FlipBookModal from "./custom/FlipBookModal";
import { LuDownload } from "react-icons/lu";

const ThoughtLeadershipForm = () => {
  const [flipbookOpen, setFlipbookOpen] = useState(false);
  const flipbookUrl = process.env.REACT_APP_FLIP_BOOK_URL;

  return (
    <div className="bg-[#FFF3ED] flex flex-col px-[4%] relative py-[8%] sm:py-[4%] ">
      <img
        src={GirlChild}
        alt="girl Child"
        className="absolute top-[20%] sm:top-0 left-0 h-[100px] sm:h-[200px] lg:h-[300px]"
      />
      <img
        src={plusStarImg}
        alt="plusStar"
        className="absolute top-[17%] sm:top-[10%] right-[5%]"
      />
      <img
        src={redHeartImg}
        alt="redHeart"
        className="absolute rotate-[40deg] sm:block hidden h-[40px] w-[40px] right-[10%] top-[30%]"
      />
      <img
        src={greenHeartImg}
        alt="greenHeart"
        className="w-[30px] lg:w-[51px] sm:block hidden h-[53px] absolute bottom-[20%] z-0 left-0 lg:left-[10%]"
      />
      <img
        src={AdmContactUsImg}
        alt="admimg"
        className="lg:block hidden max-w-[350px] absolute bottom-[0%] z-0 right-0"
      />

      <div>
        <CustomHeading
          smTextSize="32px"
          text={"Get your thoughts leadership guide"}
          textSize="60px"
          textColor="#d31c4f"
          textAlign="center"
          leading="82px"
        />
        <p className="text-center text-[#101010] text-base sm:text-2xl mt-3 font-normal font-Lato leading-6 sm:leading-[33.60px]">
          Choose a Brochure to learn more about us!
        </p>
      </div>
      <div className="flex flex-col sm:flex-row justify-center mt-[50px] lg:px-[4%] gap-[2rem] sm:gap-[4rem]">
        {/* 1st brouchure box */}
        <div className="flex flex-col  gap-4 bg-[#E6EBFF] border border-[#7C419833] min-w-[320px] px-5 py-[50px] pr-10 rounded-xl">
          <img src={BookImg} alt="bookImage" className="h-10 w-10" />
          <div className="flex flex-col items-start gap-1">
            <h1 className="text-center text-black text-2xl font-semibold leading-[33.60px]">
              Love Blossoms Here
            </h1>
            {/* <p className="text-black text-base font-normal leading-snug">
              Lorem ipsum
            </p> */}
          </div>
          <div
            // onClick={() => setView(true)}
            onClick={() =>
              window.open(
                flipbookUrl,
                "_blank",
                "noreferrer",
                "noopener"
              )
            }
            className="flex items-start lg:items-center flex-col gap-1 lg:flex-row justify-between"
          >
            <div className="w-fit h-[54px] cursor-pointer px-10 py-4 bg-[#d31c4f] rounded-xl justify-center items-center gap-3 inline-flex">
              <div className="text-white text-base font-semibold  leading-snug">
                View Flipbook
              </div>
            </div>
          </div>
        </div>
        {/* 2nd brouchure box */}
        <div className="flex flex-col gap-4 bg-[#FEEFFF] border border-[#D31C4F33] min-w-[320px] pr-10 px-5 py-[50px] rounded-xl">
          <img src={PinkBookImg} alt="bookImage" className=" h-10 w-10" />
          <div className="flex flex-col items-start gap-1">
            <h1 className="text-center text-black text-2xl font-semibold leading-[33.60px]">
              Curriculum of Love
            </h1>
            {/* <p className="text-black text-base font-normal leading-snug">
              Lorem ipsum
            </p> */}
          </div>
          <div className="flex items-start lg:items-center flex-col gap-1 lg:flex-row justify-between">
            <div
              onClick={() => {
                setFlipbookOpen(true);
              }}
              className="w-fit h-[54px] cursor-pointer px-10 py-4 bg-[#d31c4f] rounded-xl justify-center items-center gap-3 inline-flex"
            >
              <div className="text-white text-base font-semibold  leading-snug">
                Download
              </div>
             <LuDownload className="ml-0 inline text-white"/>
            </div>
          </div>
        </div>
      </div>
      {flipbookOpen && <FlipBookModal setFlipBookOpen={setFlipbookOpen} />}
    </div>
  );
};

export default ThoughtLeadershipForm;
